document.addEventListener('DOMContentLoaded', () => {
  const DURATION = 400;
  const section = document.querySelector('.faq-page');
  if (!section) return;

  document.body.classList.add('faq-sticky-fix');

  const tabs = section.querySelectorAll('[data-faq-tab]');
  const groups = section.querySelectorAll('[data-faq-group]');
  const content = section.querySelector('.faq-content');
  const searchInput = section.querySelector('[data-faq-search]');
  const noResults = section.querySelector('[data-faq-no-results]');
  let activeCategory = 'all';

  const resetStyles = (el) => {
    el.style.maxHeight = '';
    el.style.overflow = '';
    el.style.opacity = '';
    el.style.padding = '';
    el.style.transition = '';
  };

  const animate = (details, isOpening) => {
    const answer = details.querySelector('.faq-item-answer');
    if (!answer || details.dataset.animating === 'true') return;
    details.dataset.animating = 'true';

    if (isOpening) {
      details.open = true;

      requestAnimationFrame(() => {
        const height = answer.scrollHeight;
        answer.style.maxHeight = '0';
        answer.style.opacity = '0';
        answer.style.overflow = 'hidden';
        answer.style.padding = '0';

        requestAnimationFrame(() => {
          answer.style.transition = `max-height ${DURATION}ms ease, opacity ${DURATION}ms ease, padding ${DURATION}ms ease`;
          answer.style.maxHeight = `${height}px`;
          answer.style.opacity = '1';
          answer.style.padding = '';
        });
      });
    } else {
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      answer.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          answer.style.transition = `max-height ${DURATION}ms ease, opacity ${DURATION * 0.6}ms ease, padding ${DURATION}ms ease`;
          answer.style.maxHeight = '0';
          answer.style.opacity = '0';
          answer.style.padding = '0';
        });
      });
    }

    setTimeout(() => {
      if (!isOpening) details.open = false;
      resetStyles(answer);
      details.dataset.animating = 'false';
    }, DURATION + 20);
  };

  const applyFilters = () => {
    const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    let totalVisible = 0;

    groups.forEach((group) => {
      if (activeCategory !== 'all' && group.dataset.faqGroup !== activeCategory) {
        group.hidden = true;
        return;
      }

      let groupVisible = 0;
      group.querySelectorAll('[data-faq-item]').forEach((item) => {
        const matches = !query || (item.dataset.faqQuestion || '').toLowerCase().includes(query);
        item.hidden = !matches;
        if (matches) groupVisible++;
      });

      const countEl = group.querySelector('[data-faq-count]');
      if (countEl) countEl.textContent = `${groupVisible} question${groupVisible !== 1 ? 's' : ''}`;

      group.hidden = groupVisible === 0;
      totalVisible += groupVisible;
    });

    if (noResults) noResults.hidden = totalVisible > 0;
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      activeCategory = tab.dataset.faqTab;
      tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
      tab.setAttribute('aria-selected', 'true');

      const container = tab.closest('.faq-sidebar-categories');
      if (container && container.scrollWidth > container.clientWidth) {
        const containerRect = container.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        container.scrollTo({
          left: container.scrollLeft + tabRect.left - containerRect.left - (containerRect.width / 2) + (tabRect.width / 2),
          behavior: 'smooth'
        });
      }

      applyFilters();

      if (window.innerWidth >= 990) {
        const scrollTarget = content.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      }
    });
  });

  if (searchInput) {
    let debounceTimer;
    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyFilters, 200);
    });
  }

  section.addEventListener('click', (e) => {
    const trigger = e.target.closest('.faq-item-trigger');
    if (!trigger) return;
    e.preventDefault();
    const details = trigger.closest('details');
    if (details) animate(details, !details.open);
  });
});
